import axios from '@/utils/axios'
const rootUrl = 'jurisdiction/website/login/'

const api = {
  Login: rootUrl + 'login',
  LoginDetail: rootUrl + 'loginDetail',
  SendSms: rootUrl + 'sendCaptcha',
  LoginOut: rootUrl + 'loginOut',
  ToSendMsg: rootUrl + 'toSendMsg',
}

export function getSmsCaptcha(parameter) {
  return axios.formRequest.post(api.SendSms, parameter)
}

export function login(parameter) {
  return axios.formRequest.post(api.Login, parameter)
}

export function loginDetail(quarter_id = '') {
  return axios.formRequest.post(api.LoginDetail, { quarter_id })
}

/**
 * 退出
 */
export function loginOut() {
  return axios.formRequest.post(api.LoginOut, {})
}

export function toSendMsg() {
  return axios.formRequest.post(api.ToSendMsg, {})
}

/**
 * 找回密码
 * 验证手机号和验证码
 */
export function verificationCode(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/account/verificationCode',
    parameter,
  )
}

/**
 * 获取登录二维码
 */
export function scanQrLogin(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/login/scanQrLogin',
    parameter,
  )
}

/**
 * 单点登录
 */
export function loginByCode(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/login/loginByCode',
    parameter,
  )
}

/**
 * 发送请求向后台获取wx.config信息
 */
export function getSignInfo(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/login/getSignInfo',
    parameter,
  )
}
